import Vue from 'vue'
const d3 = Object.assign({}, require('d3-request'), require('d3-selection'), require('d3-format'), require('d3-geo'), require('d3-scale'), require('d3-array'), require('d3-transition'), require('d3-ease'), require('d3-axis'))

const resourceEndpoint = 'https://www.straitstimes.com/multimedia/graphics/json/'

export const store = Vue.observable({
  rawData: null,
  timeseries: null,
  sortBy: null
})

d3.json(resourceEndpoint + '2019-ncov/timeseries.json', timeseries => {
  d3.json(resourceEndpoint + '1Bic3Z0b2t5aB1BoKcrQ_8zphKq9b95ZUPVfI3rH-SLU/929734161.json', latest => {
    const d = new Date(latest[0].timestamp + ':00.000Z')
    d.setHours(d.getHours() - 12)
    const latestDate = d.toISOString().slice(0, 10)
    latest.forEach(row => {
      row.date = latestDate
    })
    timeseries = timeseries.filter(row => row.date < latestDate)
    store.rawData = Object.freeze(latest)
    store.timeseries = Object.freeze(latest.concat(timeseries))
  })
})
